require('./time-series-analysis.jade')

createChartOptions = (scoreData, target) ->
  chart:
    renderTo: target[0]
    type: 'line'
    backgroundColor: 'transparent'
    marginRight: 30 # ticket 10543
    marginTop: 55 # ticket 10686
  credits:
    enabled: false
  title:
    text: null
  plotOptions:
    series:
      marker:
        symbol: 'circle'
        lineWidth: 4
        lineColor: null
      point:
        events:
          mouseOver: ->
            plotIndex = this.x
            serieIndex = this.series.index
            localStorage.setItem "PLOT_INDEX_ANALYSIS", plotIndex
            localStorage.setItem "SERIE_INDEX_ANALYSIS", serieIndex
            unless localStorage.getItem("TRANSITION_FROM_ANALYSIS")
              localStorage.setItem "TRANSITION_FROM_ANALYSIS", '1'
  tooltip:
    useHTML: true
    borderWidth: 0
    borderRadius: 0
    backgroundColor: null
    shadow: false
    style:
      pointerEvents: ''
    formatter: ->
      "<a class='score-wrap' href='/round-detail/#{this.point.id}' style='background-color: #{this.series.color};' zindex='1'>
      <span class='play-date'>#{this.point.play_date}</span>
      <br/>
      <span class='score'>#{@y}</span>
      </a>"
    positioner: (boxWidth, boxHeight, point) ->
      pointX = point.plotX
      pointY = point.plotY
      x: pointX + 15
      y: pointY - 20

  legend:
    floating: true
    borderWidth: 2
    backgroundColor: '#FFFFFF'
    verticalAlign: 'top'
    align: 'right'
    layout: 'vertical'
  yAxis:
    title:
      text: null
    labels:
      style:
        color: '#000'
        fontWeight: 'bold'
    min: 0
  xAxis:
    type: 'linear'
    minorTickPosition: 'inside'
    categories: scoreData.categories
  series: scoreData.series

TimeSeriesAnalysisDirective = ->
  restrict: "A"
  replace: false
  templateUrl: "analysis-charts/time-series-analysis/time-series-analysis.jade"
  scope:
    scoreData: '=scoreData'
  link: (scope, element) ->
    target = element.find(".chart")
    localStorage.removeItem("TRANSITION_FROM_ANALYSIS")
    plotIndex = localStorage.getItem("PLOT_INDEX_ANALYSIS")
    serieIndex = localStorage.getItem("SERIE_INDEX_ANALYSIS")

    scope.$watch (-> scope.scoreData), ->
      chart = new Highcharts.Chart createChartOptions(scope.scoreData, target)
      if chart.tooltip and plotIndex and serieIndex
        chart.tooltip.refresh(chart.series[serieIndex].points[plotIndex])

TimeSeriesAnalysisDirective.$inject = [

]

module.exports = TimeSeriesAnalysisDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/analysis-charts/time-series-analysis/time-series-analysis-directive.coffee